import React from 'react';
import { Form } from 'react-bootstrap';

export const GlobalFilter = ({ filter, setFilter }) => {
	return (
		<>
			<div className="d-flex justify-content-between">
				Sök Personal:
			</div>

			<Form.Control
				type="search"
				value={filter || ''}
				onChange={e => setFilter(e.target.value)}
				placeholder="Sök..."
				className="w-50"
			/>
		</>
	);
};